export default "__VITE_ASSET__CtohLPAc__"